// tr strings for messages/studioOptions.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studioOptions: Dict = {
  "studioOptions.pitch.title": "Ses perdesi",
  "studioOptions.pitch.hint":
    "Yarım ton cinsinden. Erkek sesinden kadın sesine mi geçiyorsun? +12 dene.",
  // aria-label, composed with stepper.lower/raise: "Drake için ses perdesini düşür"
  "studioOptions.pitch.label": "{name} için ses perdesini",
  "studioOptions.pitch.maleToFemale": "Erkek → kadın",
  "studioOptions.pitch.femaleToMale": "Kadın → erkek",
  "studioOptions.pitch.original": "Orijinal",
  "studioOptions.stepper.lower": "{label} düşür",
  "studioOptions.stepper.raise": "{label} yükselt",
  "studioOptions.effect.title": "Efekt",
  "studioOptions.effect.hint":
    "Aynı anda bir tane. Kaldırmak için tekrar dokun.",
  "studioOptions.effect.none": "Yok",
  "studioOptions.effect.onVocals": "Vokallerde",
  "studioOptions.effect.onSong": "Şarkının tamamında",
  "studioOptions.autotune.title": "Autotune",
  "studioOptions.autotune.switch": "Vokalleri tona oturt",
  "studioOptions.autotune.hint":
    "Hafif bir rötuştan belirgin robotik sese kadar.",
  "studioOptions.autotune.light": "Hafif",
  "studioOptions.autotune.medium": "Orta",
  "studioOptions.autotune.strong": "Güçlü",
  "studioOptions.mix.title": "Miks",
  "studioOptions.mix.vocalVolume": "Vokal seviyesi",
  "studioOptions.mix.vocalVolumeHint":
    "Müziğe göre daha yüksek ya da daha alçak, dB cinsinden.",
  // aria-label, composed with stepper.lower/raise: "vokal seviyesini düşür"
  "studioOptions.mix.vocalVolumeLabel": "vokal seviyesini",
  "studioOptions.mix.backing": "Arka vokalleri ayır",
  "studioOptions.mix.backingHint":
    "Şarkıda armoni ya da ad-lib varsa daha temiz sonuç verir.",
  "studioOptions.mix.vocalsOnly": "Ses dosyam sadece vokal",
  "studioOptions.mix.vocalsOnlyHint":
    "Vokalleri müzikten ayırma adımını atlar.",
  "studioOptions.name.title": "Cover adı",
  "studioOptions.name.placeholder": "İsteğe bağlı",

  "studioOptions.summary.pitch": "Ses perdesi {values}",
  "studioOptions.summary.autotune": "Autotune",
  "studioOptions.summary.vocals": "Vokal {value}",
  "studioOptions.summary.backing": "Arka vokaller ayrıldı",
  "studioOptions.summary.vocalsOnly": "Sadece vokal girişi",
  "studioOptions.summary.default": "Orijinal perde, efekt yok",

  "studioOptions.video.previewAria": "Marble Run önizlemesi",
  "studioOptions.video.headline": "Seslerin yarışıyor. Kim öndeyse o söylüyor.",
  "studioOptions.video.body":
    "Liderlik değiştikçe ses de değişir, sözler ekranda görünür. TikTok ve Reels'te paylaşmaya hazır.",
  "studioOptions.video.crown": "Taç, kimin söylediğini gösterir",
  "studioOptions.video.pickLook": "Bir görünüm seç",
  "studioOptions.video.customise": "Özelleştir",
  "studioOptions.video.surprise": "Beni şaşırt",
  "studioOptions.video.marbles": "Bilyeler ve pist",
  "studioOptions.video.sky": "Gökyüzü",
  "studioOptions.video.font": "Söz yazı tipi",
  "studioOptions.video.stars": "Gökyüzünde yıldızlar",
  "studioOptions.theme.midnight": "Gece yarısı",
  "studioOptions.theme.neon": "Neon",
  "studioOptions.theme.ocean": "Okyanus",
  "studioOptions.theme.royal": "Kraliyet",
  "studioOptions.theme.lava": "Lav",
  "studioOptions.theme.gold": "Altın",

  "studioOptions.upload.empty":
    "Bu dosya boş. Lütfen şarkı dosyasını yeniden seç.",
  "studioOptions.upload.tooBig":
    "Dosya boyutu 75 MB'ı aşıyor! Lütfen daha küçük bir dosya yükle.",
  "studioOptions.upload.tooLong":
    "Ses süresi 6 dakikayı aşıyor! Lütfen daha kısa bir dosya yükle.",
  "studioOptions.upload.invalid": "Lütfen geçerli bir ses dosyası yükle",
  "studioOptions.upload.unexpected": "Beklenmeyen bir hata oluştu.",
  "studioOptions.upload.uploading": "Yükleniyor...",
  "studioOptions.upload.coverAlt": "kapak",
  "studioOptions.upload.dropIt": "Bırak",
  "studioOptions.upload.dropHere": "Ses dosyanı buraya bırak",
  "studioOptions.upload.browse": "Dosyalara göz at",
  "studioOptions.upload.formats": "MP3, WAV ya da M4A · en fazla 6 dakika",
  "studioOptions.upload.dropOrBrowse":
    "Bir ses dosyası bırak ya da göz atmak için tıkla",
  "studioOptions.upload.limits": "Maks. 75 MB, 6 dk • MP3, WAV, M4A",

  "studioOptions.mic.denied":
    "Kayıt yapmak için tarayıcında mikrofon erişimine izin ver.",
  "studioOptions.mic.notFound": "Kayıt için mikrofon bulunamadı.",
  "studioOptions.mic.prepareFailed": "Yükleme konumu hazırlanamadı.",
  "studioOptions.mic.fileFailed": "Dosya yüklenemedi.",
  "studioOptions.mic.uploadFailed": "Mikrofon kaydı yüklenemedi.",
  "studioOptions.mic.previewFailed": "Ses önizlemesi çalınamadı.",
  "studioOptions.mic.start": "Kaydı başlat",
  "studioOptions.mic.stop": "Kaydı durdur",
  "studioOptions.mic.tapRecord": "Kaydetmek için dokun",
  "studioOptions.mic.tapStop": "Durdurmak için dokun",
  "studioOptions.mic.clickRecord": "Kaydetmek için tıkla",
  "studioOptions.mic.processing": "İşleniyor...",
  "studioOptions.mic.playPreview": "Önizlemeyi çal",
  "studioOptions.mic.pausePreview": "Önizlemeyi duraklat",
  "studioOptions.mic.yourRecording": "Kaydın",
  "studioOptions.mic.use": "Bu kaydı kullan",
  "studioOptions.mic.again": "Yeniden kaydet",
  "studioOptions.mic.continue": "Devam et",
};

export default studioOptions;
